export const GET_PROCESS_TYPES = "GET_PROCESS_TYPES";
export const GET_PROCESS_TYPE = "GET_PROCESS_TYPE";
export const ADD_PROCESS_TYPE = "ADD_PROCESS_TYPE";
export const DELETE_PROCESS_TYPE = "DELETE_PROCESS_TYPE";
export const UPDATE_PROCESS_TYPE = "UPDATE_PROCESS_TYPE";
